import { propertyType } from 'shared/constants.json';

/**
 * Decides whether a goal passes the check-in template's team filter.
 *
 * The team filter is a no-op when no teams are configured. Otherwise a goal
 * matches when any of its space-type property values references one of the
 * configured teams.
 *
 * @param {{ properties: Array }} goal
 * @param {string[]} teamIds uids of the teams configured on the template
 * @returns {boolean}
 */
export const goalMatchesTeams = (goal, teamIds) => {
  if (teamIds.length === 0) {
    return true;
  }

  return goal.properties
    .filter((pv) => pv.property.type === propertyType.space)
    .flatMap((pv) => pv.spaces.map((s) => s.uid))
    .some((spaceId) => teamIds.includes(spaceId));
};
